import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import TrainingPlansDrawerActionButton from "@Components/training-plans/training-plans-drawer/training-plans-drawer-action-button";
import { useTrainingPlansDrawerContext } from "@Context/game/training-plans/training-plans-drawer-context";
import { faPen, faXmark } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

const TrainingPlansDrawerHeader = () => {
  const { i18n } = useI18n();
  const { closeDrawer, handleEdit } = useTrainingPlansDrawerContext();

  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between">
      <Typography variant="text1xl700" color="dsBase.v200">
        {i18n("training-plans.drawer.title")}
      </Typography>
      <Stack direction="row" spacing={1.5}>
        <HapticsButtonWrapper>
          <TrainingPlansDrawerActionButton ariaLabel={i18n("training-plans.drawer.action.edit")} icon={faPen} onClick={handleEdit} />
        </HapticsButtonWrapper>
        <HapticsButtonWrapper>
          <TrainingPlansDrawerActionButton ariaLabel={i18n("training-plans.drawer.action.close")} icon={faXmark} onClick={closeDrawer} />
        </HapticsButtonWrapper>
      </Stack>
    </Stack>
  );
};

export default TrainingPlansDrawerHeader;
